<script setup>
import InstitutionBadge from '@/components/shared/InstitutionBadge.vue';

defineProps({
  title: {
    type: String,
    default: null,
  },
  image: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="flex items-center">
    <InstitutionBadge
      :icon="['fas', 'building']"
      :imageSource="image"
      class="mr-3"
    />

    <span :aria-label="title" class="h700">{{ title }}</span>
  </div>
</template>
